export enum CanUserEnter {
  Yes = 'Yes',
  No = 'No',
  Optional = 'Optional',
}
